import { SpidCheckRequest } from "@api/client";
import { errorHandler } from "core/store/config";
import { useAppDispatch } from "core/store/hooks";
import { useEffect } from "react";
import { Spinner } from "react-bootstrap";
import { useSearchParams } from "react-router-dom";
import { webhookConfirmIdentification } from "../_redux/actions";
import "./style.scss";

const IdentityVerificationWebhook: React.FC = () => {
	const [searchParams] = useSearchParams();

	const dispatch = useAppDispatch();

	const confirmIdentification = () => {
		let ticket = searchParams.get("ticket");
		let err = searchParams.get("err");

		if (ticket) {
			let request: SpidCheckRequest = {
				ticket,
				err: err || undefined,
			};

			dispatch(webhookConfirmIdentification(request))
				.unwrap()
				.catch(() => {
					confirmIdentification();
				});
		} else {
			errorHandler("Ticket not found", dispatch, true);
		}
	};

	useEffect(() => {
		confirmIdentification();
	}, []);

	return (
		<div className="p-5 identity-verification-page">
			<h2 className="text-muted">Verifica in corso...</h2>

			<Spinner variant="primary" />
		</div>
	);
};
export default IdentityVerificationWebhook;
